import { DispatchAction } from "@iolabs/redux-utils";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    useMediaQuery,
    useTheme,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import React, { useRef, useState } from "react";
import Icon from "../../../Icon/Icon";
import EquipmentDialog from "../EquipmentDialog/EquipmentDialog";
import useStyles from "./styles";
import { onEquipmentCatalogue } from "../../../../redux/mapping";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import messages from "./messages";
import { exportEquipment, importEquipment } from "../../../../packages/Api/data/equipment/client";
import SecuredComponent from "../../../../redux/keyclock/SecuredComponent/SecuredComponent";
import NullableTooltip from "../../../NullableTooltip/NullableTooltip";
import ExporterImporter from "../../../ExporterImporter/ExporterImporter";

interface IEquipmentDialogWrapperProps {}

const EquipmentDialogWrapper: React.FC<IEquipmentDialogWrapperProps> = () => {
    const classes = useStyles();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const dispatch = useDispatch<DispatchAction>();

    const [open, setOpen] = useState<boolean>(false);
    const [selectedEquipmentIds, setSelectedEquipmentIds] = useState<number[]>([]);
    const [addModeActive, setAddModeActive] = useState<boolean>(false);

    const equipmentDialogRef = useRef();

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSelectedEquipmentIds = (rowIDs: number[]) => {
        setSelectedEquipmentIds(rowIDs);
    };

    const handleAddModeActive = (active: boolean) => {
        setAddModeActive(active);
    };

    // translations
    const intl = useIntl();
    const transExport = intl.formatMessage({ ...messages.export });
    const transImport = intl.formatMessage({ ...messages.import });
    const transEquipmentCatalogue = intl.formatMessage({ ...messages.equipmentCatalogue });
    const transCreateNewEquipment = intl.formatMessage({ ...messages.createNewEquipment });
    const transEquipment = intl.formatMessage({ ...messages.equipment });
    const transDevice = intl.formatMessage({ ...messages.device });
    const transAddToPosition = intl.formatMessage({ ...messages.addToPosition });

    return (
        <SecuredComponent permission={{resource: "mapping", scope: "mapping:update", isProject: true}}>
            <IconButton
                aria-label="add"
                color="primary"
                className={clsx("globalAddButton", classes.addButton)}
                onClick={handleOpen}
            >
                <Icon name="plus" size={20} />
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="equipment-position-dialog-title"
                aria-describedby="equipment-position-dialog-description"
                maxWidth={false}
                fullWidth
                fullScreen={fullScreen}
                className={classes.root}
                scroll="paper"
            >
                <DialogTitle id="equipment-position-dialog-title">
                    {transEquipmentCatalogue}
                </DialogTitle>
                <DialogContent classes={{ root: classes.dialogContentRoot }}>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <EquipmentDialog
                        ref={equipmentDialogRef}
                        addModeActive={addModeActive}
                        selectedEquipmentIds={selectedEquipmentIds}
                        handleAddModeActive={handleAddModeActive}
                        handleSelectedEquipmentIds={handleSelectedEquipmentIds}
                        handleClose={handleClose}
                    />
                </DialogContent>
                <DialogActions classes={{ root: classes.dialogActionsRoot }}>
                    {/*<NullableTooltip title="Create new equipment" placement="top">*/}
                    {/*    <IconButton*/}
                    {/*        aria-label="add"*/}
                    {/*        color="primary"*/}
                    {/*        className={clsx("globalAddButton", classes.addButton)}*/}
                    {/*        onClick={() => {*/}
                    {/*            // @ts-ignore*/}
                    {/*            equipmentDialogRef?.current?.handlePrepareAddEquipment();*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        <Icon name="plus" size={20} />*/}
                    {/*    </IconButton>*/}
                    {/*</NullableTooltip>*/}
                    <SecuredComponent permission={{resource: "mapping", scope: "mapping:update", isProject: true}}>
                        <NullableTooltip title={"Creation disabled, only in ERP"}>
                            <Button
                                variant="outlined"
                                color="default"
                                size="medium"
                                disabled={true}
                                onClick={() => {
                                    // @ts-ignore
                                    equipmentDialogRef?.current?.handlePrepareAddEquipment();
                                }}
                            >
                                {transCreateNewEquipment}
                            </Button>
                        </NullableTooltip>
                    </SecuredComponent>
                    <Box className={classes.exportImport}>
                        <ExporterImporter
                            fileName={"Equipment.xlsx"}
                            exportLabel={transExport}
                            importLabel={transImport}
                            exportCallback={(data) => {
                                exportEquipment();
                            }}
                            importCallback={importEquipment}
                            onImportDoneCallback={(response) => {
                                dispatch(onEquipmentCatalogue({ }))
                            }}
                            importPermission={{resource: "mapping", scope: "equipment:import", isProject: true}}
                            exportPermission={{resource: "mapping", scope: "equipment:export", isProject: true}}
                            disableImport={true}
                        />
                    </Box>
                    <SecuredComponent permission={{resource: "mapping", scope: "mapping:update", isProject: true}}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="secondary"
                            size="medium"
                            disabled={selectedEquipmentIds?.length === 0 || addModeActive}
                            onClick={() => {
                                // @ts-ignore
                                equipmentDialogRef?.current?.handleAddEquipmentToPosition();
                                handleClose();
                            }}
                        >
                            {selectedEquipmentIds?.length > 1 ? transEquipment : transDevice} {transAddToPosition}
                        </Button>
                    </SecuredComponent>
                </DialogActions>
            </Dialog>
        </SecuredComponent>
    );
};

export default EquipmentDialogWrapper;
